/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionType {
  PERM_IS_SYS_ROOT = 'PERM_IS_SYS_ROOT',
  PERM_IS_SYS_ADMIN = 'PERM_IS_SYS_ADMIN',
  PERM_IS_SYS_BILLING = 'PERM_IS_SYS_BILLING',
  PERM_IS_ACCOUNT_ADMIN = 'PERM_IS_ACCOUNT_ADMIN',
  PERM_IS_FLEET_MANAGER = 'PERM_IS_FLEET_MANAGER',
  PERM_IS_USER_ADMIN = 'PERM_IS_USER_ADMIN',
  PERM_IS_ASSET_ADMIN = 'PERM_IS_ASSET_ADMIN',
  PERM_IS_ELEVATED_USER = 'PERM_IS_ELEVATED_USER',
  PERM_IS_DRIVER = 'PERM_IS_DRIVER',
  PERM_IS_WORK_ORDER_ASSIGNEE = 'PERM_IS_WORK_ORDER_ASSIGNEE',
  PERM_VIEW_ALL_TERMINALS = 'PERM_VIEW_ALL_TERMINALS',
  PERM_EDIT_USER_PASSWORDS = 'PERM_EDIT_USER_PASSWORDS',
  PERM_VIEW_PORTAL_DRIVERS_TAB = 'PERM_VIEW_PORTAL_DRIVERS_TAB',
  PERM_VIEW_PORTAL_DRIVER_LOGS_TAB = 'PERM_VIEW_PORTAL_DRIVER_LOGS_TAB',
  PERM_EDIT_PORTAL_DRIVER_LOGS_TAB = 'PERM_EDIT_PORTAL_DRIVER_LOGS_TAB',
  PERM_VIEW_PORTAL_VIOLATIONS_TAB = 'PERM_VIEW_PORTAL_VIOLATIONS_TAB',
  PERM_VIEW_PORTAL_UNIDENTIFIED_DRIVING_EVENTS_TAB = 'PERM_VIEW_PORTAL_UNIDENTIFIED_DRIVING_EVENTS_TAB',
  PERM_VIEW_PORTAL_HOS_REPORTS_TAB = 'PERM_VIEW_PORTAL_HOS_REPORTS_TAB',
  PERM_VIEW_PORTAL_DVIR_HISTORY_TAB = 'PERM_VIEW_PORTAL_DVIR_HISTORY_TAB',
  PERM_VIEW_PORTAL_MALFUNCTIONS_AND_DATA_DIAGNOSTICS = 'PERM_VIEW_PORTAL_MALFUNCTIONS_AND_DATA_DIAGNOSTICS',
  PERM_VIEW_PORTAL_LOG_EDITS = 'PERM_VIEW_PORTAL_LOG_EDITS',
  PERM_EDIT_TERMINALS = 'PERM_EDIT_TERMINALS',
  PERM_EDIT_DVIR_FORMS = 'PERM_EDIT_DVIR_FORMS',
  PERM_EDIT_DRIVERS = 'PERM_EDIT_DRIVERS',
  PERM_EDIT_EQUIPMENT = 'PERM_EDIT_EQUIPMENT',
  PERM_VIEW_ALL_USERS = 'PERM_VIEW_ALL_USERS',
  PERM_EDIT_FUEL_RECEIPTS_TAB = 'PERM_EDIT_FUEL_RECEIPTS_TAB',
  PERM_EDIT_PORTAL_VIOLATIONS_TAB = 'PERM_EDIT_PORTAL_VIOLATIONS_TAB',
  PERM_EDIT_PORTAL_UNIDENTIFIED_DRIVING_EVENTS_TAB = 'PERM_EDIT_PORTAL_UNIDENTIFIED_DRIVING_EVENTS_TAB',
  PERM_EDIT_PORTAL_LOG_EDITS = 'PERM_EDIT_PORTAL_LOG_EDITS',
  PERM_VIEW_CERTIFIED_LOGS = 'PERM_VIEW_CERTIFIED_LOGS',
  PERM_VIEW_DVIR_REPORTS = 'PERM_VIEW_DVIR_REPORTS',
  PERM_EDIT_DVIRS = 'PERM_EDIT_DVIRS',
  PERM_EDIT_JOB_SITES = 'PERM_EDIT_JOB_SITES',
  PERM_VIEW_PORTAL_JOB_SITES_TAB = 'PERM_VIEW_PORTAL_JOB_SITES_TAB',
  PERM_EDIT_WORK_ORDERS = 'PERM_EDIT_WORK_ORDERS',
  PERM_VIEW_PORTAL_WORK_ORDERS_TAB = 'PERM_VIEW_PORTAL_WORK_ORDERS_TAB',
  PERM_VIEW_PORTAL_FUEL_RECEIPTS_TAB = 'PERM_VIEW_PORTAL_FUEL_RECEIPTS_TAB',
  PERM_VIEW_PORTAL_IFTA_REPORTS_TAB = 'PERM_VIEW_PORTAL_IFTA_REPORTS_TAB',
  PERM_VIEW_PORTAL_WORK_ORDER_REPORTS_TAB = 'PERM_VIEW_PORTAL_WORK_ORDER_REPORTS_TAB',
  PERM_EDIT_ALERTS = 'PERM_EDIT_ALERTS',
  PERM_VIEW_PORTAL_LOCATIONS_TAB = 'PERM_VIEW_PORTAL_LOCATIONS_TAB',
  PERM_EDIT_CARRIER_INFORMATION = 'PERM_EDIT_CARRIER_INFORMATION',
  PERM_ADD_VEHICLE = 'PERM_ADD_VEHICLE',
  PERM_EDIT_VEHICLE = 'PERM_EDIT_VEHICLE',
  PERM_DELETE_VEHICLE = 'PERM_DELETE_VEHICLE',
  PERM_ADD_TRAILER = 'PERM_ADD_TRAILER',
  PERM_EDIT_TRAILER = 'PERM_EDIT_TRAILER',
  PERM_DELETE_TRAILER = 'PERM_DELETE_TRAILER',
  PERM_VIEW_SUB_ACCOUNTS = 'PERM_VIEW_SUB_ACCOUNTS',
  PERM_SUPPORT_PORTAL_TAB_VIEW = 'PERM_SUPPORT_PORTAL_TAB_VIEW',
}
